import React from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './index.css'
import App from './components/login'
import { CookiesProvider } from 'react-cookie'

const target = document.getElementById('cb-login');
if (target) {
  const root = createRoot(target)
  root.render(
    <CookiesProvider>
      <GoogleOAuthProvider clientId="169464380401-bgrmg1vt8cv5iv8h0rkkt03bc98nbess.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>
    </CookiesProvider>)
}